import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Providers
import { useWizardProvider } from '../../../../Components/shared/WizardContext'

// Avatar
import BotHead from '../../../../Components/shared/Avatar/BotHeadColored'

// Icons
import { IconTimes, IconArrowLeft } from '../../../../Components/shared/Icon'

// Constants
import { SIGN_UP_STEPS } from '../../../../constants/signUp'

// Components
import { Text, Panel, Button, Breakpoint } from '../../../../Components'
import { useSignUpProvider } from '../SignUpContext'
import Steps from '../Steps'

// Styles
import styles from './Body.module.scss'

const SignUpBody = ({ className, handleClose: handleCloseProp }) => {
  const { currentStep, goBack } = useWizardProvider()
  const { handleIframeClose, iFramed } = useSignUpProvider()

  const showHandleCloseBtn = Boolean(handleCloseProp || iFramed)
  const handleClose = iFramed ? handleIframeClose : handleCloseProp
  const MediumScreenBreakpoint = Breakpoint(850)
  const showBackBtn = currentStep === SIGN_UP_STEPS.USER_FIRST_AND_LAST

  return (
    <Panel className={classnames(styles.panel, className)}>
      <div className={styles.bodyContainer}>
        <MediumScreenBreakpoint.Large>
          <div className={styles.imagePanel} />
        </MediumScreenBreakpoint.Large>
        <div className={styles.column}>
          <div
            className={classnames(
              styles.closeRow,
              showBackBtn && styles.backRow
            )}
          >
            {showBackBtn && (
              <Button
                minimal
                className={styles.backButton}
                iconStart={IconArrowLeft}
                onClick={goBack}
              />
            )}
            {showHandleCloseBtn && (
              <Button
                minimal
                onClick={handleClose}
                className={styles.closeButton}
                iconEnd={IconTimes}
              />
            )}
          </div>
          <div className={styles.formContainer}>
            <div className={styles.botHeaderRow}>
              <div className={styles.botHead}>
                <BotHead />
              </div>
              <Text
                size='l'
                weight='light'
                variant='neutralCool'
                variantCount='900'
              >
                homebot
              </Text>
            </div>
            <Steps handleClose={handleClose} />
          </div>
        </div>
      </div>
    </Panel>
  )
}

SignUpBody.propTypes = {
  className: PropTypes.string,
  handleClose: PropTypes.func,
}

export default SignUpBody
